import constants from 'common/constants'

import {ONBOARDING_FILE_PREFILL} from './ActionTypes/ApiActionTypes'

/**
 * `POST onboarding/prefill`: the Teachers file, already uploaded in pieces, is read again in the
 * background for the Students and Teacher Allocation steps. Answers 202 with
 * `result.drafts: {students: {id, job}, allocation: {id, job}}`; each result is kept as a draft
 * titled `onboarding-prefill` (see ONBOARDING_PREFILL_DRAFT_TITLE), and a new call replaces the
 * previous drafts. Fire and forget: the steps read the drafts when they open.
 *
 * @param {{uploadId: string; useCaseKeys?: string[]}} body
 */
export const prefillOnboardingFromFile = (body, onSuccess, onFailure) => {
  return {
    type: ONBOARDING_FILE_PREFILL,
    payload: {
      apiUrl: constants.api_onboarding_prefill,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}
